export const NO_CONTRACT = 0;
export const YEARLY = 12;



// WEBPACK FOOTER //
// ./app/constants/contractPeriods.js